var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"points":"66.8,193.2 109.2,150.8 256,297.6 402.8,150.8 445.2,193.2 256,382.4 ","id":"polygon3055","transform":"matrix(0.04741853,0,0,-0.04741853,-3.1391437,22.171806)"}})}
var staticRenderFns = []

export { render, staticRenderFns }